<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <ik-data-table
      ref="dataTable"
      :custom-on-row-click="showJson"
      :model="model"
      :use-default-action="false"
      entity-name="MilkTeaMachine"
      icon="mdi-cards"
    >
      <template #footer="{tableItems}">
        <v-btn
          color="amber lighten-4 black--text"
          elevation="0"
          @click="resendAll(tableItems)"
        >
          <v-icon left>
            mdi-export
          </v-icon>
          {{ $t('resendAllFailedMission') }}
        </v-btn>
        <v-btn
          color="amber lighten-4 black--text"
          elevation="0"
          @click="cancelAll(tableItems)"
        >
          <v-icon left>
            mdi-cancel
          </v-icon>
          {{ $t('cancelFailedMission') }}
        </v-btn>
      </template>
      <template
        #item.operation="{item}"
      >
        <v-btn
          :height="!$vuetify.breakpoint.lgAndUp ? '40px' : ''"
          :icon="!$vuetify.breakpoint.lgAndUp"
          :style="!$vuetify.breakpoint.lgAndUp ? 'border-radius: 12px; background: #f57c00;' : ''"
          :width="!$vuetify.breakpoint.lgAndUp ? '40px' : ''"
          color="amber lighten-4 black--text"
          elevation="0"
          small
          @click.stop="resend(item)"
        >
          <template v-if="!$vuetify.breakpoint.lgAndUp">
            <v-icon color="white">
              mdi-email-fast-outline
            </v-icon>
          </template>
          <template v-if="$vuetify.breakpoint.lgAndUp">
            <div
              :class="!$vuetify.breakpoint.lgAndUp ? 'text-truncate' : ''"
              :style="!$vuetify.breakpoint.lgAndUp ? 'max-width: 100px;' : ''"
            >
              {{ $t('forceResend') }}
            </div>
          </template>
        </v-btn>
      </template>
    </ik-data-table>
    <v-dialog
      v-model="showDetailInfo"
      max-width="600px"
    >
      <v-card class="pa-4">
        <div>
          <div class="d-flex align-center justify-center">
            <v-spacer />
            <v-btn
              icon
              @click="showDetailInfo = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>

          <div class="mt-2 text-body-1 font-weight-regular">
            <json-viewer
              :value="currentData"
              copyable
            />
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import MilkTeaSetting, {
  cancelAllMissions,
  resendAllMissions,
  resendMissionsById
} from '@/model/dataLayer/api/MilkTeaSetting'
import { showSuccessMessage } from '@/model/utils/utils'
import JsonViewer from 'vue-json-viewer'

export default {
  name: 'HourlyReport',
  components: {
    IkDataTable,
    JsonViewer
  },
  data () {
    return {
      currentData: null,
      showDetailInfo: false,
      model: MilkTeaSetting
    }
  },
  methods: {
    async showJson (item) {
      this.currentData = JSON.parse(item.taskRequest)
      this.showDetailInfo = true
    },
    async resend (item) {
      await resendMissionsById(item.id)
      await this.$refs.dataTable.reload()
      showSuccessMessage(this.$t('successful'))
    },
    async resendAll () {
      await resendAllMissions()
      await this.$refs.dataTable.reload()
      showSuccessMessage(this.$t('successful'))
    },
    async cancelAll () {
      await cancelAllMissions()
      await this.$refs.dataTable.reload()
      showSuccessMessage(this.$t('successful'))
    }
  }
}
</script>

<style scoped>

</style>
